const initalState = null;

const rfiListReducer = (state = initalState, action) => {
  const { type, data } = action;

  switch (type) {
    case "ADD_RFI_LIST":
      return data;
    default:
      return state;
  }
};

const submissionRFIDetailReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_RFI_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

const submissionRFIResponseReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_RFI_RESPONSE_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

const submissionRFICommentReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_RFI_COMMENT_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

export {
  rfiListReducer,
  submissionRFIDetailReducer,
  submissionRFIResponseReducer,
  submissionRFICommentReducer,
};
